import * as types from "@/redux/ActionTypes";

// Layer state interface
export interface LayersState {
  selectedLayers: string[];
  mapLayer: string;
  geozoneLayer: boolean;
  networkLayer: boolean;
  assetLayer: boolean;
  infraLayer: boolean;
  layers: string[];
}

// Action interfaces
interface StoreLayersAction {
  type: typeof types.STORE_LAYERS;
  data: Partial<LayersState>;
}

interface DefaultAction {
  type: string;
  data?: unknown;
}

type Action = StoreLayersAction | DefaultAction;

const initialState: LayersState = {
  selectedLayers: [],
  mapLayer: "",
  geozoneLayer: false,
  networkLayer: false,
  assetLayer: false,
  infraLayer: false,
  layers: [],
};

const myReducer = (state: LayersState = initialState, action: Action): LayersState => {
  switch (action.type) {
    case types.STORE_LAYERS:
      localStorage.setItem(
        "snt_control_layer",
        JSON.stringify({ ...state, ...(action as StoreLayersAction).data })
      );
      return { ...state, ...(action as StoreLayersAction).data };
    default:
      return state;
  }
};

export default myReducer;
